module.exports = require("./ar-LY.js");